
<template>
  <div class="modal modal-blur fade" id="modal-select-temp-users" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select Users</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div class="modal-body">
          <h5>Use Ctrl to Select Multiple People</h5>
          <select size="10" multiple="multiple" style="width: 100%;" v-model="selectedUsers">
            <option v-for="user in users" :value="user.username">{{user.firstName}} {{user.lastName}} ({{user.role == 'admin' ? 'Admin' : user.role == 'account' ? 'Account Manager' : user.role == 'basic' ? "Assistant" : "N/A"}})</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click.prevent="onSelectUsers">Select Users</button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import WebLLCRESTApi from "../api/api";
  export default {
    data() {
      return {
        selectedUsers: []
      }
    },
    
    props: {
      users: Array
    },
    
    methods: {
      onSelectUsers() {
        this.$emit("selected", this.selectedUsers);
      }
    }
    
   

  }
</script>



// WEBPACK FOOTER //
// src/components/SelectUserDlg.vue